import { formatDate } from "@utdanningsdirektoratet/utils/date";
import { LinkButton } from "@utdanningsdirektoratet/button";
import { Icon } from "@utdanningsdirektoratet/icon";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { RichTextView } from "@utdanningsdirektoratet/richtext";
import { PubliseringsStatus, Sektor } from "../../../../ApiClients";
import { urls } from "../../../../logic/initialState";
import { DATE_FORMAT } from "../../../../constants/dateFormats";
import { useHoering, useUttalelse } from "../../../../hooks";
import { routes } from "../../../../routes";

const InnsendtHeader = ({
  innsenderStilling,
  referanse,
  show = false,
}: {
  show?: boolean;
  innsenderStilling?: string | null;
  referanse?: string | null | undefined;
}) => {
  const { data: hoering } = useHoering();
  const { data: uttalelse } = useUttalelse();

  if (!show || !uttalelse) return null;

  const { eksternId, navnSkjult } = uttalelse;

  return (
    <div className="Header Header--innsendt">
      <div className="Header-buttons Grid-12-12">
        {hoering.publiseringsStatus === PubliseringsStatus.PublisertÅpen && (
          <LinkButton
            href={routes.hoering(uttalelse.høringId)}
            className="Header-button"
          >
            {(props) => {
              return (
                <Link
                  {...props}
                  to={props.href!}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <FormattedMessage id="innsendtUttalelse.nyUttalelse" />
                </Link>
              );
            }}
          </LinkButton>
        )}
        <LinkButton
          target="_blank"
          rel="noopener noreferrer"
          href={urls.lastNedUttalelse(eksternId)}
          className="Header-button"
        >
          <Icon icon="document" type="small" placement="before" />
          <FormattedMessage id="innsendtUttalelse.lastNedUttalelse" />
        </LinkButton>
      </div>
      <div className="Header-content Grid-12-12">
        <div className="Header-title">
          <FormattedMessage id="innsendtUttalelse.status" />
        </div>
        <div>
          <RichTextView html={uttalelse.status ?? ""} />
        </div>
      </div>
      <div className="Grid-12-12">
        <div className="Header-content Grid-lg-3-12 Grid-6-12">
          <div className="Header-title">
            <FormattedMessage id="innsendtUttalelse.innsendtAv" />
          </div>
          {navnSkjult ? (
            <em>
              <FormattedMessage id="innsendtUttalelse.skjultAv" />
            </em>
          ) : (
            uttalelse.innsenderNavn
          )}
        </div>
        <div className="Header-content Grid-lg-3-12 Grid-6-12">
          <div className="Header-title">
            <FormattedMessage id="innsendtUttalelse.innsendtDato" />
          </div>
          {uttalelse.innsendt ? (
            formatDate(uttalelse.mottatt ?? new Date(), DATE_FORMAT)
          ) : (
            <FormattedMessage id="innsendtUttalelse.ikkeInnsendt" />
          )}
        </div>
        <div className="Header-content Grid-lg-3-12 Grid-6-12">
          <div className="Header-title">
            {uttalelse.sektor === Sektor.Enkeltperson &&
            uttalelse.innsenderRepresentererEtikett ? (
              uttalelse.innsenderRepresentererEtikett
            ) : (
              <FormattedMessage id="innsendtUttalelse.paVegneAv" />
            )}
          </div>
          {navnSkjult && uttalelse.sektor === Sektor.Enkeltperson ? (
            <em>
              <FormattedMessage id="innsendtUttalelse.skjultAv" />
            </em>
          ) : (
            uttalelse.påVegneAv
          )}
        </div>
        {uttalelse.malgruppe ? (
          <div className="Header-content Grid-lg-3-12 Grid-6-12">
            <div className="Header-title">
              <FormattedMessage id="innsendtUttalelse.malgruppe" />
            </div>
            {uttalelse.malgruppe}
          </div>
        ) : null}
      </div>
      <div className="Grid-12-12">
        {innsenderStilling ? (
          <div className="Header-content Grid-6-12">
            <div className="Header-title">
              <FormattedMessage id="innsendtUttalelse.stilling" />
            </div>
            {innsenderStilling}
          </div>
        ) : null}
        {referanse && referanse !== "eInnsyn" ? (
          <div className="Header-content Grid-6-12">
            <span>
              <div className="Header-title">
                <FormattedMessage id="header.varReferanse" />
              </div>
              {referanse}
            </span>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default InnsendtHeader;
